import React, { useState, useCallback, useEffect } from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

export const TextSearchField = ({ attributeName, onSetField, filters }) => {
  const [fieldValue, setFieldValue] = useState("");
  const [fieldError, setFieldError] = useState("");

  useEffect(() => {
    setFieldValue(filters[attributeName]?.[0]?.name ?? "");
  }, [attributeName, filters]);

  const onFieldChanged = useCallback(
    value => {
      setFieldValue(value);
      let errorMessage = "";
      if (value.length > 255) {
        errorMessage = "You must input less then 255 characters";
        setFieldError(errorMessage);
      } else {
        setFieldError("");
        onSetField(value, attributeName);
      }
    },
    [attributeName, onSetField]
  );

  return (
    <StyledTextField
      variant="outlined"
      margin="dense"
      error={Boolean(fieldError)}
      helperText={fieldError}
      value={fieldValue}
      onChange={evt => onFieldChanged(evt.target.value)}
      aria-label="meta value input"
      placeholder={attributeName || null}
      size="small"
    />
  );
};

const StyledTextField = styled(TextField)`
  margin: 0;
`;

TextSearchField.propTypes = {
  attributeName: PropTypes.string,
  onSetField: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired
};
